import React, {useCallback, useEffect, useRef, useState} from 'react';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Header from "./components/layout/Header";
import GlobalStyles from "src/styles/globalStyles";
import MainPageView from "src/pages/MainPage/view";
import styled from 'styled-components';
import NotFoundView from "src/pages/NotFound/view";
import {Helmet, HelmetProvider} from "react-helmet-async";

const ClientOnly = ({ children }: { children: React.ReactNode }) => {
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, []);

    if (!hasMounted) {
        return null;
    }

    return <>{children}</>;
};

function App() {
    const [currentSection, setCurrentSection] = useState('mainSection');
    const [isScrolling, setIsScrolling] = useState(false);
    const mainPageViewRef = useRef<{ scrollToSection: (section: string) => void } | null>(null);

    const onSectionChange = (section: string) => {
        setCurrentSection(section);
    };

    const scrollToSection = useCallback((section: string) => {
        if (mainPageViewRef.current) {
            mainPageViewRef.current.scrollToSection(section);
        }
    }, []);

    const handleNavigation = (targetSection: string) => {
        if (isScrolling) return;
        scrollToSection(targetSection);
    }

    const handleLogoClick = () => handleNavigation('mainSection');
    const handleMoveEventSection = () => handleNavigation('eventSection');
    const handleMovePartnerSection = () => handleNavigation('partnerSection');


    const router = createBrowserRouter([
        {
            path: "/",
            element: (
                <Layout>
                    <ClientOnly>
                        <Helmet>
                            <meta name="robots" content="index" />
                        </Helmet>
                    </ClientOnly>
                    <Header
                        currentSection={currentSection}
                        onLogoClick={handleLogoClick}
                        onMoveEventSection={handleMoveEventSection}
                        onMovePartnerSection={handleMovePartnerSection}
                    />
                    <Content>
                        <MainPageView
                            ref={mainPageViewRef}
                            currentSection={currentSection}
                            onSectionChange={onSectionChange}
                        />
                    </Content>
                </Layout>
            ),
        },
        {
            path: "*",
            element: (
                <NotFoundView/>
            ),
        }
    ]);
    // 리엑트 렌더 시점에 루트 요소 디스플레이 처리
    useEffect(() => {
        const userAgent = navigator.userAgent
        if (!userAgent.includes('react-hydratable')) {
            const rootElement = document.getElementById('root')
            rootElement && rootElement.classList.add('display_root')
        }
    }, [])
    return (
        <HelmetProvider>
            <RouterProvider router={router}/>
            <GlobalStyles/>
        </HelmetProvider>
    );
}

export default App;


const Layout = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex: 1;
  position: relative;
`;
